import { useConfig } from 'config/useConfig';
import styles from './AVCReportModalContent.module.scss';
import { REPORT_MODAL_NAMES } from 'config/labels';
const darkColor = getComputedStyle(document.documentElement).getPropertyValue('--color-dark-9').trim();
const lightColor = getComputedStyle(document.documentElement).getPropertyValue('--color-dark-0').trim();
interface Props {
  imageSrc?: {
    crossSection?: string;
    angle0?: string;
    angle120?: string;
    angle240?: string;
    threeD?: string;
  }
  avcScore : number;
  volume : number;
}

export default function AVCReportModalContent({
  imageSrc,
  avcScore,
  volume,
}: Props) {
  const names = REPORT_MODAL_NAMES.avc;
  const {config} = useConfig();
  return (
    <div className={styles['modal-container']}>
      <div className={styles['modal-container-1']}>
        <div className={styles['cross-section-container']}>
          <div className={styles['footer-toggle']}>
            <div className={styles['line99']}/>
            {names.sections.crossSection.title}
          </div>
          <img src={imageSrc?.crossSection}/>
          <div className={styles['cross-section-thumbnails-container']}>
            <div className={styles['cross-section-thumbnails']} >
              <div style={{ position: 'relative' }}>
                <img
                  src = {imageSrc?.angle0}
                  alt = "angle0"
                />
                <span> {names.sections.crossSection.angles.angle0} </span>
              </div>
              <div style={{ position: 'relative' }}>
                <img
                  src = {imageSrc?.angle120}
                  alt = "angle120"
                />
                <span> {names.sections.crossSection.angles.angle120} </span>
              </div>
              <div style={{ position: 'relative' }}>
                <img
                  src = {imageSrc?.angle240}
                  alt = "angle240"
                />
                <span> {names.sections.crossSection.angles.angle240} </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles['trd-model-container']}>
          <div className={styles['footer-toggle']}>
            <div className={styles['line99']}/>
            {names.sections.model3d.title}
          </div>
          <img src = {imageSrc?.threeD}/>
          <div className={styles['trd-model-data-container']}
            style={{backgroundColor:config.generalSetting.theme==='Dark Mode'?darkColor:lightColor}}>
            <div className={styles['trd-model-data']}>
              <div className={styles['aortic-value']}>
                <div className={styles['data-column']}>
                  <span className={styles['data-value']}> {names.sections.model3d.labels.avcScore} </span>
                  <span className={styles['data-label']}> {avcScore} </span>
                </div>
                <div className={styles['data-column']}>
                  <span className={styles['data-value']}> {names.sections.model3d.labels.volume} </span>
                  <span className={styles['data-label']}> {volume} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
